import { addDaysToDate, getTodayYYYYMMDD } from './dates';

export const calculateMaxCategory = (categories: string[], maxCategoryIndex: number, daysInOneBar: number): string | undefined => {
  if (maxCategoryIndex >= categories.length) {
    const lastCategoryMin = categories[categories.length - 1];
    let maxLastCategory = addDaysToDate(lastCategoryMin, daysInOneBar);

    const today = getTodayYYYYMMDD();
    if (maxLastCategory > today) {
      maxLastCategory = today;
    }

    return maxLastCategory;
  }
  return categories[maxCategoryIndex];
};
